import React, { useEffect, useState } from 'react';

const Pascal = () => {
  let canvas: HTMLCanvasElement;
  let c: CanvasRenderingContext2D;
  const cW = 1000;
  const cH = 1000;
  let interval: NodeJS.Timeout;

  const maxLine = 53;
  const rectSize = Math.floor(cW / maxLine);
  const [divisor, setDivisor] = useState(2);

  useEffect(() => {
    canvas = document.getElementsByTagName('canvas')[0] as HTMLCanvasElement;
    canvas.width = cW;
    canvas.height = cH;
    c = canvas.getContext('2d') as CanvasRenderingContext2D;
    calculate();
  }, [divisor]);

  function calculate() {
    const n: number[] = [];
    let x = 0;
    let y = 0;
    let i = 0;
    let d = divisor;
    if (d <= 1) {
      d = 2;
    }
    clearInterval(interval);
    c.clearRect(0, 0, cW, cH);
    interval = setInterval(loop, 0);
    function loop() {
      if (i > 2 && x != y && x != 0) {
        n[i] = n[i - y - 1] + n[i - y]; // calculate next number by adding the two numbers above
      } else {
        n[i] = 1;
      }
      /*for (let j = 10; j < 200; j += 50) {
       */ if (n[i] > Math.pow(10, 20)) {
        //modulo in javascript does not work with big numbers
        n[i] -= Math.pow(10, 20); //reducing the size of the number to draw a bigger triangle
      }
      /*}*/
      if (n[i] % d == 0) {
        c.fillStyle = 'yellow';
      } else {
        c.fillStyle = 'blue';
      }
      //c.fillText(""+n[i], x*xSpace+canvas.width/2-y*xSpace/2, y*ySpace+20);
      c.fillRect(x * rectSize + cW / 2 - (y * rectSize) / 2, y * rectSize, rectSize, rectSize);
      x++;
      i++;
      if (x > y) {
        y = x;
        x = 0;
      }
      if (y > 53) {
        clearInterval(interval);
      }
    }
  }

  return (
    <main>
      <h1>Pascal&apos;s Triangle Fractal</h1>
      <p>
        By coloring the numbers in Pascal&apos;s triangle which are divisible by 2, you get the Sierpiński triangle. Doing this
        with other divisors leads to multiple different fractals. Enter your divisor below to create a unique fractal:
      </p>
      <input type='number' placeholder='Divisor' id='divisor' value={divisor} onChange={(e) => setDivisor(+e.target.value)} />

      <canvas className='reactive' />
    </main>
  );
};
export default Pascal;
